const sso_domain = process.env.SSO_DOMAIN;
export default sso_domain;


// WEBPACK FOOTER //
// ./src/api/index.js